import api from './api'
import moment from 'moment'

function activate(id) {
  return api.post(`/admin/products/${id}/activate`)
}

function create(product) {
  product.publishDate = product.publishDate
    ? moment(product.publishDate)
        .utc()
        .format('YYYY-MM-DD')
    : null

  return api.post('/admin/products', { ...product })
}

function deactivate(id) {
  return api.delete(`/admin/products/${id}/deactivate`)
}

function destroy(id) {
  return api.delete(`/admin/products/${id}`)
}

function list(params = {}, productType) {
  const q = { ...params.q, productType }
  return api.get('/admin/products', { params: { ...params, q } })
}

function duplicate(id) {
  return api.post(`/admin/products/${id}/duplicate`)
}

function show(id) {
  return api.get(`/admin/products/${id}`)
}

function update(body) {
  body.publishDate = body.publishDate
    ? moment(body.publishDate)
        .utc()
        .format('YYYY-MM-DD')
    : null

  return api.patch(`/admin/products/${body.id}`, body)
}

export default {
  activate,
  create,
  deactivate,
  duplicate,
  destroy,
  list,
  show,
  update,
}
